import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardHeader, CircularProgress, Link, List, ListItem } from "@mui/material";
import { useRootStore } from "../../hooks/useRootStore";
import { useEffect, useState } from "react";
import { Employee } from "../../data/Employee";
import { Issue } from "../../data/Issue";
import { ArrowDropDownIcon } from "@mui/x-date-pickers/icons";
import ChangeSkillDialog from "../ChangeSkillDialog";
import { Skill } from "../../data/Skill";

export default function IssuePreferredWorkersWidget({ issue }: { issue: Issue }) {
    const { api } = useRootStore();
    const [workers, setWorkers] = useState([] as Employee[]);
    const [loading, setLoading] = useState(true);
    const [workersChanging, setWorkersChanging] = useState(false);

    useEffect(() => {
        api.getIssuePreferredWorkers(issue.ID).then(workers => {
            setWorkers(workers);
            setLoading(false);
        });
    }, [api, issue])

    return (
        <>
            {workersChanging ? <ChangeSkillDialog issue={issue} onSubmit={(_changedSkill: Skill, preferredWorkers: Employee[]) => { setWorkers(preferredWorkers); setWorkersChanging(false); }} onCancel={() => setWorkersChanging(false)} /> : ''}
            <Card className="issue-widget">
                <CardHeader title="Предпочтительные" className="card-header" />
                <Box>
                    {loading
                        ?
                        <Box sx={{ textAlign: 'center', p: 5 }}>
                            <CircularProgress />
                        </Box>
                        :
                        <>
                            {workers.length == 0 ?
                                <Box>
                                    <Box sx={{ pb: 2 }}>Нет предпочтительных сотрудников</Box>
                                    <Box sx={{ textAlign: 'center' }}>
                                        <Button size="small" onClick={() => setWorkersChanging(true)}>Изменить</Button>
                                    </Box>
                                </Box> :
                                <Accordion sx={{ border: 'none', boxShadow: 'none', p: 0 }} >
                                    <AccordionSummary expandIcon={<ArrowDropDownIcon />} sx={{ p: 0, boxShadow: 'none' }}>
                                        {workers.length} человек(а)
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ p: 0 }} >
                                        <List>
                                            {workers.map(x => <ListItem sx={{ p: 0, pb: 0.5 }} key={x.ID}><Link href={`/employees/${x.ID}`}>{x.Name}</Link></ListItem>)}
                                        </List>
                                        <Box sx={{ textAlign: 'center' }}>
                                            <Button size="small" onClick={() => setWorkersChanging(true)}>Изменить</Button>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                            }
                        </>
                    }
                </Box>
            </Card>
        </>
    )
}